import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-terra px-4 py-20 text-center text-white sm:py-24" data-id="element-57" data-mp="3n1rz4lm72lkc">
      <Reveal className="mx-auto max-w-3xl" data-id="element-58" data-mp="3s1wf8aj6xea1">
        <h2 className="text-[1.9rem] font-semibold leading-[1.12] tracking-tight sm:text-[3rem]" data-id="element-59" data-mp="3s038kv8kuu21">
          ¿Lista/o para enseñar Arte con{' '}
          <span className="italic" data-id="element-60" data-mp="2zea32dvwd1bk">confianza?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-white/80 sm:text-lg" data-id="element-61" data-mp="2zbnxgjskgvvz">
          Más de 2.000 docentes argentinos ya transformaron sus clases. Hoy es
          tu turno.
        </p>
        <CTAButton variant="white" className="mt-10 focus-visible:ring-offset-brand-terra" data-id="element-62" data-mp="3e2enbmallkwg">
          Quiero el Pack Arte Lista
        </CTAButton>
        <p className="mt-6 text-[11px] font-medium text-white/80 sm:text-xs" data-id="element-63" data-mp="2gkwrztbp9pmv">
          <span aria-hidden="true" data-id="element-64" data-mp="2lkj4g0jpf1um">⚡</span> Descarga inmediata
          <span className="px-1.5" aria-hidden="true" data-id="element-65" data-mp="26vk5bjtizy0z">
            ·
          </span>
          <span aria-hidden="true" data-id="element-66" data-mp="21w7kt5q4n31k">🔒</span> Pago 100% seguro
          <span className="px-1.5" aria-hidden="true" data-id="element-67" data-mp="21wpp8pmy0nkk">
            ·
          </span>
          <span aria-hidden="true" data-id="element-68" data-mp="1x3mu4d2ip629">✅</span> Garantía 7 días
        </p>
      </Reveal>
    </section>;
}